export default {"src":"/_next/static/media/app-store.f17453d2.svg","height":65,"width":214,"blurWidth":0,"blurHeight":0};